import { Map } from "immutable";

import { getState } from "services/queryClient";

import { schoolClassesKey, schoolsKey } from "../../../consts";

export const getSchoolClasses = (schoolId: string) => {
  return (getState([schoolClassesKey, schoolId]) || []) as any[];
};

export const getSchoolClassesAlphabeticallyByName = (schoolId: string) => {
  const schoolClasses = getSchoolClasses(schoolId);
  return schoolClasses.sort((a: any, b: any) => (a.name > b.name ? 1 : -1));
};

export const getAllSchoolClasses = () => {
  const schools = (getState(schoolsKey) || []) as any[];
  return schools.reduce((classes, school) => {
    const schoolClasses = getSchoolClasses(school.schoolId);
    return [...classes, ...schoolClasses];
  }, []);
};

export const getAllSchoolClassesAlphabeticallyByName = () => {
  const schoolClasses = getAllSchoolClasses();
  return schoolClasses.sort((a: any, b: any) => (a.name > b.name ? 1 : -1));
};

export const getAllSchoolClassesIdNameMap = () => {
  const schoolClasses = getAllSchoolClasses();
  return schoolClasses.reduce((idNameMap: any, schoolClass: any) => {
    return idNameMap.set(schoolClass.classId, schoolClass.name);
  }, Map());
};
